<template>
  <div>
    <div class="page-title">CaptureJS Settings</div>
    <TextField
      placeholder=""
      label="Script Source"
      v-model="localValue.data.script_src"
    />
  </div>
</template>

<script>
import mixin from "./addon-form.mixin";

export default {
  extends: mixin,
};
</script>

<style scoped lang="scss"></style>
